import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { Button, Grid, Link, Popover } from '@mui/material';
import ProjectFileCabinetModal from 'components/file-cabinet-folders/modals/project-file-cabinet-modal';
import { HasPermission } from 'components/has-permission';
import { useSyncSelectedProject } from 'hooks/useSyncSelectedProject';
import { ITEMS } from './constants';
import ChevronsIcon from 'assets/icons/buttons/chevrons.svg';
import { styles } from './styles';

export const NavigationDropdown = ({ projectId }: { projectId: number }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [isFileCabinetModalOpen, setIsFileCabinetModalOpen] = useState(false);

  const { project: projectData } = useSyncSelectedProject(projectId);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenFileCabinet = () => {
    setIsFileCabinetModalOpen(true);
    localStorage.setItem('isFileCabinetModalOpen', 'true');
  };

  const open = Boolean(anchorEl);
  const activeNavigationLabel = (() => {
    if (pathname?.includes('project-dashboard')) return 'Schedule';
    if (pathname?.includes('media')) return 'Media';

    return 'Selections';
  })();

  return (
    <>
      <Grid sx={styles.container}>
        <Button
          sx={styles.button}
          variant="outlined"
          id="schedule-actions-popper-button"
          onClick={handleClick}
          endIcon={<ChevronsIcon />}
        >
          {activeNavigationLabel}
        </Button>
        <Popover
          sx={styles.popover}
          id="schedule-actions-navigation-dropdown"
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          onClick={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          {ITEMS.map((item) => {
            if ('action' in item) {
              return (
                <HasPermission
                  key={item.id}
                  type="single"
                  subject={item.permissionSubject}
                  scope={item.permissionScope}
                >
                  <Grid sx={styles.navigationItem} onClick={handleOpenFileCabinet}>
                    {item.name}
                  </Grid>
                </HasPermission>
              );
            }

            if ('permissionScope' in item && 'permissionSubject' in item) {
              return (
                <HasPermission
                  key={item.id}
                  type="single"
                  subject={item.permissionSubject}
                  scope={item.permissionScope}
                >
                  <Link
                    sx={styles.navigationItem}
                    component={NavLink}
                    to={`${item.path}/${projectId}`}
                  >
                    {item.name}
                  </Link>
                </HasPermission>
              );
            }

            return (
              <Link
                key={item.id}
                sx={styles.navigationItem}
                component={NavLink}
                to={`${item.path}/${projectId}`}
              >
                {item.name}
              </Link>
            );
          })}
        </Popover>
      </Grid>
      {isFileCabinetModalOpen && (
        <ProjectFileCabinetModal
          open={isFileCabinetModalOpen}
          projectId={projectId}
          title={projectData?.name}
          projectFolderId={projectData?.folderId}
          handleClose={() => {
            localStorage.removeItem('isFileCabinetModalOpen');
            setIsFileCabinetModalOpen(false);
            navigate(pathname);
          }}
        />
      )}
    </>
  );
};
